import { useEffect, useState } from "react";
import { GridLoader } from "react-spinners";
import { CustomLoaderComponent } from "../custom-loader-component/custom-loader-component";
import "./report-loading-component.scss";

type ReportLoadingReadyMessage = {
    type: "report-loading-ready";
};

type ReportLoadingTextMessage = {
    type: "report-loading-message";
    text: string;
};

const DEFAULT_LOADING_MESSAGE = "PDF wird erstellt..."; // This is just a fallback. The actual message should be sent from the parent window to support localization and dynamic messages.

export function ReportLoadingComponent() {
    const [message, setMessage] = useState(DEFAULT_LOADING_MESSAGE);

    useEffect(() => {
        const onMessage = (event: MessageEvent<ReportLoadingTextMessage>) => {
            if (event.origin !== window.location.origin) {
                return;
            }

            if (event.data?.type !== "report-loading-message") {
                return;
            }

            if (typeof event.data.text !== "string" || event.data.text.trim().length === 0) {
                return;
            }

            setMessage(event.data.text);
        };

        window.addEventListener("message", onMessage);

        if (window.opener && !window.opener.closed) {
            const readyMessage: ReportLoadingReadyMessage = {
                type: "report-loading-ready",
            };

            window.opener.postMessage(readyMessage, window.location.origin);
        }

        return () => {
            window.removeEventListener("message", onMessage);
        };
    }, []);

    return <div className="report-loading-component">
        <CustomLoaderComponent>
            <GridLoader
              className="spinner"
              loading={true}
            />
        </CustomLoaderComponent>
        <p className="report-loading-component__message">{message}</p>
    </div>;
}

export default ReportLoadingComponent;
